export const SMALL = 72;
export const MEDIUM = 224;
export const LARGE = 364;
